export enum OverlappingRulePreferrer {
	None = 0,
	MainWorkProfile = 1,
	SpecificWorkProfile = 2
}